import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleLogin(role = "attendee") {
  localStorage.setItem("ah_google_role", role);
  const redirectUrl = window.location.origin + (role === "organizer" ? "/organizer" : "/");
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { googleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const role = localStorage.getItem("ah_google_role") || "attendee";
    localStorage.removeItem("ah_google_role");
    const dest = location.pathname || "/";
    (async () => {
      try {
        const user = await googleSession(sessionId, role);
        window.history.replaceState(null, "", dest);
        toast.success(`Welcome, ${user.name}`);
        navigate(user.role === "organizer" ? "/organizer" : dest, { replace: true, state: { user } });
      } catch (e) {
        toast.error(formatApiError(e));
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, googleSession]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-amber-500 border-t-transparent" />
    </div>
  );
}
